<section class="w-full flex flex-wrap justify-center items-center overflow-hidden">
    <div class="w-full flex flex-wrap content-start bg-white dark:bg-gray-900 rounded-lg p-4">
        <img class="w-6" src="https://cloud.behkhaan.ir/assets/icons/beh-logo.svg">
        <!-- img -->
        <div class="w-full flex flex-wrap justify-center mt-4 relative">
            <img class="aspect-2/1 w-full object-cover rounded-lg"
                [src]="data?.id | image : imageType.userBanner : data?.hasWallpaper" [alt]="data?.fullName">

            <div class="z-20 absolute rounded-full border-white dark:border-gray-900 top-[82px] border-[6px]">
                <img class="rounded-full object-cover min-h-20 min-w-20 max-h-20 max-w-20"
                    [src]="data?.id | image: imageType.userAvatar : data?.hasPhoto"
                    onerror="this.src='assets/images/default/default_avatar.svg'" />
            </div>
        </div>
        <!-- data -->
        <div class="w-full mt-[4rem] flex flex-col items-center justify-center">
            <p class="text-sm text-gray-900 font-bold">{{data?.firstName}}</p>
            @if(data?.uniqeName){
            <p class="text-xs font-regular text-gray-500 mt-1">{{data?.uniqeName + '@'}}</p>
            }
        </div>
        <button class="w-full flex justify-center btn-xs btn-blue-flat !rounded-[10px] mt-4">دنبال کردن</button>

        <!-- rate and review -->
        <div class="w-full flex justify-center items-center mt-4">
            <div class="flex items-center border-l border-gray-100 dark:border-gray-600 px-4">
                <!-- <span class="text-sm text-gray-500">{{data?.reviewsCount}}</span> -->
                <span class="text-xs font-medium text-gray-500">{{data?.reviewsCount}}</span>
                <span class="icon notepad-edit-regular text-gray-500 text-base mr-1"></span>
            </div>

            <div class="flex items-center px-4">
                <!-- <span class="text-sm text-gray-500">{{data?.ratesCount}}</span> -->
                <span class="text-xs font-medium text-gray-500">{{data?.ratesCount}}</span>
                <span class="icon star-regular text-gray-500 text-base mr-1"></span>
            </div>
        </div>
    </div>

    <div class="flex flex-wrap flex-col justify-center items-center mt-4">
        <p class="text-xs text-gray-700 dark:text-gray-200 font-medium">بهخوان | شبکهٔ اجتماعی کتاب</p>

        <div class="relative w-full my-4">
            <div class="border-t border-gray-500 dark:border-gray-400 absolute top-1/2 left-0 right-0"></div>
            <p
                class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-green-10 dark:bg-green-1000 px-2 text-green-500 text-sm font-medium">
                behkhaan.ir</p>
        </div>
    </div>
</section>